import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsService } from '../../../services/forms.service'
import { NotificationService } from '../../../services/notificationService.service'
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators, FormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import {
    GlobalConfig,
    ToastrService,
    ToastContainerDirective,
    ToastNoAnimation,
} from 'ngx-toastr';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { ErrorStateMatcher } from '@angular/material/core';

import { cloneDeep, random } from 'lodash-es';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { OverlayConfig } from '@angular/cdk/overlay';
import { MatOptionSelectionChange } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
import { DOCUMENT } from '@angular/common';

interface Option {
    label: string;
    id: string;
}

@Component({
    selector: 'app-plati-ridicari-auto',
    templateUrl: './plati-ridicari-auto.component.html',
    styleUrls: ['./plati-ridicari-auto.component.css']
})
export class PlatiRidicariAutoComponent implements OnInit {

    myControl = new FormControl();
    optionsArr!: Option[];
    filteredOptions!: Observable<Option[]>;
    selectedOptionValue: any;

    errorTitle: string = environment.customNotifications.headers.atention
    errorIcon: string = environment.customNotifications.icons.error
    errorType: string = environment.customNotifications.icons.error
    successTitle: string = environment.customNotifications.headers.success
    successIcon: string = environment.customNotifications.icons.success
    successType: string = environment.customNotifications.icons.success

    showSuccess: boolean = false
    formResult: any = null

    @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent | undefined;
    @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any> | undefined;
    public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
    public loading = false;
    public loadingTemplate: TemplateRef<any> | undefined;

    matcher = new MyErrorStateMatcher();

    options = {
        progressBar: true,
        preventDuplicates: true,
        closeButton: true,
        iconClasses: {
            success: 'toast-success',
            error: 'toast-error',
            warning: 'toast-warning',
            info: 'toast-info',
        },
    };

    // options!: GlobalConfig;
    filter!: GlobalConfig;
    uploading: any = {};

    formData: any = FormGroup;

    constructor(
        private fb: FormBuilder,
        private service: FormsService,
        private notificationService: NotificationService,
        private toastr: ToastrService,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
        );

        this.formData = new FormGroup({
            numar_auto: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(12)
            ])),
            termeni_conditii: new FormControl(false, Validators.compose([
                Validators.requiredTrue
            ]))
            // verificare_auto: new FormControl('', []) // here will be google recaptcha
        })
    }

    get numar_auto() {
        return this.formData.get('numar_auto');
    }

    private _filter(value: string): Option[] {
        if (value != null) {
            const filterValue = value.toLowerCase();
            return this.optionsArr.filter(option => option.label.toLowerCase().includes(filterValue));
        } else {
            return [];
        }
    }

    ngOnInit(): void {
    }

    async checkAuto() {
        console.log(this.formData.value, 'here are my data?')
        this.loading = true
        // if(!this.formData.valid) {
        // 	let errorMsg = "Ne pare rău, dar informațiile introduse nu sunt valide. Vă rugăm să reîncercați!"
        // 	await this.notificationService.warningSwal(
        // 		this.errorTitle, errorMsg, this.errorIcon
        // 	);
        // 	return false
        // }else {
        this.service.checkPaymentReferenceRidicari(this.formData.value)
            .then(async (response) => {
                console.log(response, 'success');
                if (response.status_code === 200 && response.total) {
                    // everything ok now, we wrap it up now
                    console.log(response)
                    this.formResult = response
                    this.showSuccess = true
                    this.loading = false;
                    return false;
                } else if (response.status_code === 400 && typeof response.message !== 'undefined') {
                    let errorMsg = response.message
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                } else {
                    let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                }
                return false
            })
            .catch(async (error) => {
                console.error(error);
                await this.notificationService.warningSwal(
                    this.errorTitle, error.message, this.errorIcon
                );
                return false;
            });
        // }

    }

    async resetForm() {
        this.formData.patchValue({
            numar_auto: '',
            termeni_conditii: false
        })
        this.formResult = null
        this.showSuccess = false
        this.formData.reset()
    }

    async processPaymentLink() {
        this.loading = true
        var self = this
        // if(!this.formData.valid) {
        // 	let errorMsg = "Ne pare rău, dar informațiile introduse nu sunt valide. Vă rugăm să reîncercați!"
        // 	await this.notificationService.warningSwal(
        // 		this.errorTitle, errorMsg, this.errorIcon
        // 	);
        // 	return false
        // }else {
        this.service.processPaymentLinkRidicari(this.formData.value)
            .then(async (response: any) => {
                console.log(response, 'success');
                if (response.status_code === 200 && response.link) {
                    // everything ok now, we wrap it up now
                    this.document.location.href = response.link;
                    this.loading = false;
                    return false;
                } else if (response.status_code === 400 && typeof response.message !== 'undefined') {
                    let errorMsg = response.message
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                } else {
                    let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                }
                return false
            })
            .catch(async (error) => {
                console.error(error);
                await this.notificationService.warningSwal(
                    this.errorTitle, error.message, this.errorIcon
                );
                return false;
            });
    }
}
